document.addEventListener('DOMContentLoaded', () => {
  const trigger = [...document.querySelectorAll('a')].find(
    a => a.textContent.trim().toLowerCase() === 'select chassis'
  );
  const panel = document.getElementById('chassis-drawer-panel');
  if (!trigger || !panel) return;

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    panel.classList.toggle('chassis-open');
  });

  document.addEventListener('click', (e) => {
    if (!panel.contains(e.target) && e.target !== trigger) {
      panel.classList.remove('chassis-open');
    }
  });
});
